import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { TournamentApiService } from '../../../../common/apis/tournament/tournament-api.service';
import { ComponentStatus, StateComponent } from '../../../../common/components/state/state.component';
import { NotificationService } from '../../../../common/services/notification.service';
import { MatDialog } from '@angular/material/dialog';
import { CreateCompetitionGroupDialogComponent } from './create-competition-group-dialog/create-competition-group-dialog.component';
import { AnalyticsService } from '../../../../common/services/analytics.service';
import { ICompetitionGroupModel } from '../../../../common/apis/competition-group/model/competitoin-group.model';
import { CompetitionGroupApiService } from '../../../../common/apis/competition-group/competition-group-api.service';
import { MatIcon } from '@angular/material/icon';
import { MatFabButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatListItem, MatListItemAvatar, MatListItemTitle, MatNavList } from '@angular/material/list';

import { MatCard, MatCardContent } from '@angular/material/card';
import { LoadingContainerComponent } from '../../../../common/components/loading-container/loading-container.component';

@Component({
  selector: 'oo-competition-group-list',
  templateUrl: './competition-group-list.component.html',
  styleUrls: ['./competition-group-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LoadingContainerComponent, MatCard, MatCardContent, MatNavList, MatListItem, RouterLink, MatListItemAvatar, MatListItemTitle, MatFabButton, MatIcon],
})
export class CompetitionGroupListComponent extends StateComponent<TournamentsListComponentState> implements OnInit {

  state: TournamentsListComponentState = {
    status: 'loading',
    competitionGroups: [],
  };
  private readonly tournamentApi = inject(TournamentApiService);
  private readonly compGroupApi = inject(CompetitionGroupApiService);
  private readonly notificationService = inject(NotificationService);
  private readonly dialog = inject(MatDialog);
  private readonly analyticsService = inject(AnalyticsService);

  ngOnInit(): void {
    this.analyticsService.trackScreenName('tournamentsList');
    this.fetchData();
  }

  async openCreateTournamentDialog(): Promise<void> {
    const created: boolean = await this.dialog.open(CreateCompetitionGroupDialogComponent)
      .afterClosed()
      .toPromise();

    if (created) {
      this.fetchData();
    }
  }

  private fetchData(): void {
    this.updateStatus('loading');
    this.compGroupApi.getUserCompGroups()
      .then((competitionGroups) => {
        this.updateState({
          competitionGroups: competitionGroups.sort((a, b) => b.createdAt - a.createdAt),
          status: 'ready',
        });
      })
      .catch(() => {
        this.updateStatus('error');
      });
  }
}

interface TournamentsListComponentState {
  status: ComponentStatus;
  competitionGroups: ICompetitionGroupModel[];
}
